'use strict';

import angular from 'angular';

const urls = {
  email: '/email',
  phone: '/phone/add',
  price: '/price'
};
const currentUserProperties = ['name', 'location', 'priceInfo'];

const fieldMap = {
  price: 'priceInfo',
};

// TODO: refactor DRY (see price_form.ctrl)
const getFullPrice = (hourlyRate, commissionRate) => {
  let fullPrice =  0;
  if (hourlyRate) {
    fullPrice = Math.ceil(hourlyRate / (100 - commissionRate) * 100);
  }
  return fullPrice;
};

export default function f($http, $q, userModel, utils, settingsLayoutConfig, logout) {
  'ngInject';

  this.progress = 10;

  function getPostUrl(fieldName) {
    var url = 'settings/' + userModel.item.id;

    url += (urls[fieldName] || '');

    return utils.getApiUrl(url);
  }

  function updateCurrentUser(fieldName, value) {
    var transFormedFieldName = fieldMap[fieldName];
    if (value && currentUserProperties.indexOf(fieldName) > -1) {
      userModel.item[fieldName] = value;
    }

    if (value && currentUserProperties.indexOf(transFormedFieldName) > -1) {
      userModel.item[transFormedFieldName] = value;
    }
  }

  function getFieldList() {
    var fields = [];

    settingsLayoutConfig.layout.forEach(function (section) {
      section.fields.forEach(function (field) {
        fields.push(field.name);
      });
    });

    return fields;
  }

  return {
    data: {},
    reset: function () {
      this.data = {};
    },
    fetch: function () {
      var deferred = $q.defer();

      $http.get(utils.getApiUrl('settings/' + userModel.item.id))
        .then(function (response) {
          this.data = response.data;

          deferred.resolve(this.data);
        }.bind(this))
        .catch(deferred.reject);

      return deferred.promise;
    },
    save: function (fieldName, newValue, postDataKey) {
      var deferred = $q.defer();
      var postData = {};

      postData[postDataKey || fieldName] = newValue;
      $http.post(getPostUrl(fieldName), postData)
        .then((response) => {
          var newFieldData = response.data && response.data[fieldName];

          this.data[fieldName] = newFieldData;
          if (fieldName === 'price') {
            newFieldData.value.fullPrice = getFullPrice(newFieldData.value.price, this.data.price.commission);
          }
          updateCurrentUser(fieldName, newFieldData.value);
          deferred.resolve(newFieldData.value);
        })
        .catch(deferred.reject);

      return deferred.promise;
    },

    getValidFieldCount: function () {
      var fields = getFieldList();
      var count = 0;
      //var half = false;

      angular.forEach(this.data || this.data, function (value, key) {
        if (this.isValid(key, this.data) && !this.isRejected(key) && fields.indexOf(key) > -1) {
          count++;
          // if (key === 'email' || key === 'phone') {
          //   if (half) {
          //     count++;
          //   } else {
          //     half = true;
          //   }
          // } else {
          //   count++;
          // }
        }
      }.bind(this));

      this.progress = count * 10;
      return count;
    },

    /**
     * Checks if specified field is valid.
     *
     * @param {String} fieldName
     * @returns {boolean}
     */
    isValid: function (fieldName, data) {
      var fieldData = (data || this.data)[fieldName];
      var value = fieldData.value;
      var isValid = false;

      switch (fieldName) {
      case 'verificationPhoto':
        isValid = Boolean(value);
        break;

      case 'phone':
        isValid = fieldData && fieldData.verified
          || userModel.hasMessenger();
        break;

      case 'email':
        isValid = fieldData && fieldData.verified;
        break;

      case 'languages':
      case 'activities':
        isValid = value && value.length;
        break;

      case 'location':
        isValid = value && value.placeId;
        break;

      case 'photos':
        isValid = value && value.length && !fieldData.isLoading;
        break;

      case 'price':
        isValid = true;
        break;

      case 'fbMessengerId':
        isValid = userModel.hasMessenger();
        isValid = true;
        break;

      default:
        isValid = Boolean(value);
        break;
      }

      return isValid;
    },

    /**
     * Checks if specified field is rejected.
     *
     * @param {String} fieldName
     * @returns {boolean}
     */
    isRejected: function (fieldName) {
      var fieldData = this.data[fieldName] || {};

      return fieldData.rejected;
    },

    // Phone/email verification

    resendEmailVerification: function () {
      return $http.get(utils.getApiUrl('settings/' + userModel.item.id + '/email/resend'));
    },

    verifyEmail: function (code) {
      var deferred = $q.defer();
      var httpPromise = $http.post(utils.getApiUrl('settings/' + userModel.item.id + '/email'), {
        code: code
      });

      httpPromise
        .then(function () {
          this.data.email.verified = true;
          deferred.resolve(this.data.email);
        }.bind(this))
        .catch(deferred.reject);

      return deferred.promise;
    },

    verifyPhone: function (code) {
      var deferred = $q.defer();
      var httpPromise = $http.post(utils.getApiUrl('settings/' + userModel.item.id + '/phone/verify'), {
        code: code
      });

      httpPromise
        .then(function () {
          this.data.phone.verified = true;
          deferred.resolve(this.data.phone);
        }.bind(this))
        .catch(deferred.reject);

      return deferred.promise;
    },

    resendPhoneVerification: function () {
      return $http.get(utils.getApiUrl('settings/' + userModel.item.id + '/phone/resend'));
    },

    cancelAccount: function (reason) {
      return $http.post(utils.getApiUrl('settings/' + userModel.item.id + '/remove_profile'), {message: reason}).then(logout);
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/settings.js